<!--
 * @Author: Niklaus
 * @Date: 2026-04-20 15:29:08
 * @LastEditTime: 2026-05-09 14:45:39
 * @LastEditors: Niklaus
 * @Description: 招商合同管理
-->
<template>
    <div>
        <contract-comp deptName="招商办公室"></contract-comp>
    </div>
</template>

<script>
import ContractComp from './ContractComp.vue'
import { getDictionary } from "@/api/system/dictbiz";
export default {
    components: { ContractComp },

    data() {
        return {
            deptArray: []
        }
    },

    // created() {
    //     getDictionary({ code: "contractCreateDept" }).then(res => {
    //         this.deptArray = res.data.data;
    //     });
    // }
}
</script>

<style scoped></style>